<template>
  <div>
    <div class="time">
      <img src="@/assets/img/time-icon-b.svg" alt="시간 아이콘" />
      <p>{{ course.startDate }}({{ course.day }}) {{ course.startTime }}~{{ course.endTime }} ({{ course.time }}분)</p>
    </div>
    <div class="coach-goal">
      <ul>
        <li>
          <h3>관심 코칭 주제</h3>
          <p class="preline">
            <font v-for="(item, index) in embedded" :key="index" :class="{ active: index == 0 }">
              {{ index + 1 }}. {{ item.parentSubject }} - {{ item.subject }}<br />
            </font>
          </p>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
export default {
  name: "inc_back",
  props: {
    sessionIdx: {
      type: [Number, String],
      default: 0,
    },
  },
  data: () => ({
    course: {},
    embedded: [],
  }),
  watch: {},
  mounted() {
    this.getCoarchingDetail();
  },
  methods: {
    getCoarchingDetail() {
      let params = {
        sessionIdx: this.sessionIdx,
      };
      this.axios
        .get("/front/coarching/reservation/detail", { params })
        .then((res) => {
          if (res.data.success) {
            this.course = res.data.contentinfo.coarchReservationList;

            this.course.startDate = dayjs(this.course.startDate).format("YYYY-MM-DD HH:mm:ss").replace(/-/g, "/");
            this.$store.commit("setCoachingDays", new Date(this.course.startDate).getDay());
            this.course.day = this.$store.state.coachingDays;

            this.course.startTime = dayjs(this.course.startDate).format("HH:mm");
            this.course.endTime = dayjs(this.course.endDate).format("HH:mm");

            let timeValue = {
              startTime: this.course.startTime,
              endTime: this.course.endTime,
            };
            this.$store.commit("setCoachingTime", timeValue);
            this.course.time = this.$store.state.coachingTime;

            this.course.startDate = dayjs(this.course.startDate).format("YYYY.MM.DD");

            this.embedded = res.data.contentinfo.userEmbeddedSurvey;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
